import InfoButton from '../../components/shell/InfoButton'
import AdminLayout from '../../components/shell/AdminLayout'
import { REPORT_CATALOG, type ReportId } from './reportCatalog'
import ReportTabs from './ReportTabs'

export default function AdminReportPage({ report }: { report: ReportId }) {
  const { title, subtitle, about, Component } = REPORT_CATALOG.find((entry) => entry.id === report)!
  return (
    <AdminLayout
      current={report}
      title={title}
      subtitle={subtitle}
      titleAddon={
        <InfoButton label={`About the ${title}`}>
          {about.map((paragraph) => (
            <p key={paragraph} className="[&:not(:first-child)]:mt-2">
              {paragraph}
            </p>
          ))}
        </InfoButton>
      }
    >
      <ReportTabs base="/admin/reports" />
      <Component />
    </AdminLayout>
  )
}
